import React from 'react'
import PropTypes from 'prop-types'

const Item = props => (
  <tr>
    <td> {props.indexKey + 1} </td>
    <td> <span className="capitalize">{props.row.serialNumber} </span></td>
    <td> <span className="capitalize">{String(props.row.isUsed)} </span></td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    name: '',
  },
  pathname: '',
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    serialNumber: PropTypes.string.isRequired,
    isUsed: PropTypes.bool.isRequired,
  }).isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
